import React, { useMemo, useState } from "react";
import { countLevels, ago, Empty, FilterChips, MARKETPLACES, Marketplace, StatusChip, Tag, utcLabel } from "./ui";

const FILTERS = [["all", "All"], ["red", "Needs dev work"], ["amber", "Pending"], ["ok", "Active"]];

export default function SubscriptionsTab({ subscriptions, filter, onFilter }) {
  const [q, setQ] = useState("");

  const counts = useMemo(() => countLevels(subscriptions, (x) => x.level), [subscriptions]);

  const rows = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return subscriptions
      .filter((x) => filter === "all" || x.level === filter)
      .filter((x) => !needle || [x.store_name, x.profile_id, x.dataset_id, x.marketplace_id, MARKETPLACES[x.marketplace_id], x.status]
        .join(" ").toLowerCase().includes(needle));
  }, [subscriptions, filter, q]);

  return (
    <>
      <div className="ams-toolbar">
        <FilterChips options={FILTERS} value={filter} onChange={onFilter} counts={counts} />
        <input className="ams-search" type="search" value={q} onChange={(e) => setQ(e.target.value)}
               placeholder="Search store, profile or dataset" aria-label="Search subscriptions" />
      </div>
      <p className="ams-hint">Current subscription per store, marketplace and dataset (an active one on the current queue wins); the rest show under Others. Red: suspended, failed or archived, on a retired queue, pending over 24 h, or not linked to a store. Orange: pending confirmation. Last record is for information: hours without conversions are normal.</p>
      <div className="ams-tablewrap">
        <table className="ams-table">
          <thead>
            <tr>
              <th>Store</th><th>Needs action</th><th>Dataset</th><th>Status</th><th>Activity</th><th>Notes</th><th>Alert</th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? rows.map((x) => (
              <tr key={x.subscription_id} className={`ams-edge--${x.level}`}>
                <td className="ams-name">
                  {x.store_name || <span className="ams-dash">Unknown store</span>}
                  <dl className="ams-idlist">
                    <dt>Market</dt><dd><Marketplace id={x.marketplace_id} /></dd>
                    <dt>Profile</dt><dd>{x.profile_id || <span className="ams-why--red">not linked</span>}</dd>
                    <dt>Queue</dt><dd>{x.queue} <span className="ams-cc">{x.region}</span></dd>
                    {x.previous && x.previous.length > 0 && (
                      <>
                        <dt>Others</dt>
                        <dd title={x.previous.map((o) => `${o.subscription_id}: ${o.status} on ${o.queue}`).join("\n")}>
                          {x.previous.length} ({x.previous.map((o) => (o.status || "").toLowerCase().replace(/_/g, " ")).join(", ")})
                        </dd>
                      </>
                    )}
                  </dl>
                </td>
                <td className="ams-why">
                  {x.level === "ok" ? <div className="ams-fine">Nothing to do</div> : <div className={`ams-why--${x.level}`}>{x.reason}</div>}
                </td>
                <td>{x.dataset_id}</td>
                <td><StatusChip status={x.status} /></td>
                <td>
                  <dl className="ams-idlist ams-idlist--wide">
                    <dt>Last record</dt><dd>{ago(x.last_record_at)}</dd>
                    <dt>Checked</dt><dd>{ago(x.last_status_check)}</dd>
                    <dt>Created</dt><dd>{x.created_date ? utcLabel(x.created_date, false) : "–"}</dd>
                  </dl>
                </td>
                <td className="ams-wrap">{x.notes}</td>
                <td><Tag level={x.level === "ok" ? "ok" : x.level} /></td>
              </tr>
            )) : (
              <Empty cols={7}>
                {filter !== "all" || q ? "No subscriptions match this filter." : "No subscriptions yet. Run subscribe_managed_stores() to create them."}
              </Empty>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
